import { FdsConfirmationModal } from '../../../../containers/Modal/FdsConfirmationModal';

type CloseConfirmationModalProps = {
  onCancelGoBack: () => void;
  handleClickCancel: () => void;
};

export const CloseConfirmationModal = ({
  onCancelGoBack,
  handleClickCancel,
}: CloseConfirmationModalProps) => (
  <FdsConfirmationModal
    dialogTestId='confirmation-modal'
    handleClickCancel={handleClickCancel}
    handleClickGoBack={onCancelGoBack}
  />
);
